module.exports = {
      id: "ic-edit-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-edit-usage",
      toString: function () {
        return this.url;
      }
    }